import { useMemo } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";
import { ScreeningStatus } from "shared/types";
import { screeningStatusTitle } from "./title";
import { cx } from "shared/utils";

export const ScreeningStatusBadge = ({
  status,
  paused,
  className
}: {
  status?: string;
  // A failed premium warnings report pauses the remaining paid reports; the
  // screening reads as paused rather than failed until someone overrides it.
  paused?: boolean;
  className?: string;
}) => {
  const { variant, title } = useMemo(() => {
    if (paused) return { variant: BadgeVariant.WARNING, title: "Paused" };

    switch (status) {
      case ScreeningStatus.Processing:
        return {
          variant: BadgeVariant.WARNING,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.Completed:
        return {
          variant: BadgeVariant.SUCCESS,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.Failed:
        return {
          variant: BadgeVariant.ERROR,
          title: screeningStatusTitle(status)
        };
      case ScreeningStatus.NotStarted:
      default:
        return {
          variant: BadgeVariant.BASE,
          title: screeningStatusTitle(status)
        };
    }
  }, [status, paused]);

  return (
    <Badge
      className={cx("shrink-0 items-center", className)}
      variant={variant}
      size={BadgeSize.SM}
    >
      {title}
    </Badge>
  );
};
